import store from "@/store";
import AdAccountService from "@/services/ad-account.service";

export default {
  data() {
    return {
      API_URL: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    setAltImg(event) {
      event.target.src = require("@/assets/images/pages/video.png")
    },
    calculateCampaignStatus(campaign) {
      const currentTime = new Date();
      const startDate = new Date(campaign.scheduleStartDate);

      if (campaign.delYn === "Y") {
        return "Deleted";
      } else if (campaign.noEndDate) {
        if (campaign.adGroups.length === 0) {
          return "Preparing";
        } else if (campaign.adGroups.filter(adGroup => adGroup.creativeGroupCount === 0 || adGroup.customTargetCount === 0).length > 0) {
          return "Preparing";
        } else {
          if (currentTime < startDate) {
            // Schedule 기간 전
            return campaign.action === "ON" ? "Ready" : "Stopped";
          } else if (currentTime >= startDate) {
            // Schedule 기간 중
            return campaign.action === "ON" ? "Running" : "Stopped";
          }
        }
      } else {
        const endDate = new Date(campaign.scheduleEndDate);

        if (currentTime > endDate) {
          // Schedule 기간 후
          return "Completed";
        } else if (campaign.adGroups.length === 0) {
          return "Preparing";
        } else if (campaign.adGroups.filter(adGroup => adGroup.creativeGroupCount === 0 || adGroup.customTargetCount === 0).length > 0) {
          return "Preparing";
        } else {
          if (currentTime < startDate) {
            // Schedule 기간 전
            return campaign.action === "ON" ? "Ready" : "Stopped";
          } else if (currentTime >= startDate && currentTime <= endDate) {
            // Schedule 기간 중
            return campaign.action === "ON" ? "Running" : "Stopped";
          }
        }
      }
    },
    calculateAdGroupListStatusCounts(adGroups) {
      const counts = {
        Total: 0,
        Preparing: 0,
        Ready: 0,
        Stopped: 0,
        Running: 0,
        Completed: 0,
        Deleted: 0
      };
      for (const adGroup of adGroups) {
        counts.Total++;
        counts[this.calculateCampaignStatus(adGroup.campaign)]++;
      }

      return counts;
    },
    bindingChartSeries(barOption, lineOption, chartData) {
      const chartOption = ["Spend", "Impression", "Click"];
      const chartSeries = [
        {
          name: barOption,
          type: "column",
          data: []
        },
        {
          name: lineOption,
          type: "line",
          data: []
        },
      ];
      chartSeries[0].type = chartOption.includes(barOption) ? "column" : "line";
      chartSeries[1].type = chartOption.includes(lineOption) ? "column" : "line";

      for (const data of chartData) {
        if (barOption === 'Spend') {
          chartSeries[0].data.push(data.spend);
        } else if (barOption === 'Impression') {
          chartSeries[0].data.push(data.impression);
        } else if (barOption === 'Click') {
          chartSeries[0].data.push(data.click);
        } else if (barOption === 'CTR') {
          chartSeries[0].data.push(data.ctr);
        } else if (barOption === 'CPM') {
          chartSeries[0].data.push(data.cpm);
        } else {
          chartSeries[0].data.push(data.cpc);
        }
      }
      for (const data of chartData) {
        if (lineOption === 'Spend') {
          chartSeries[1].data.push(data.spend);
        } else if (lineOption === 'Impression') {
          chartSeries[1].data.push(data.impression);
        } else if (lineOption === 'Click') {
          chartSeries[1].data.push(data.click);
        } else if (lineOption === 'CTR') {
          chartSeries[1].data.push(data.ctr);
        } else if (lineOption === 'CPM') {
          chartSeries[1].data.push(data.cpm);
        } else {
          chartSeries[1].data.push(data.cpc);
        }
      }
      return chartSeries;
    },
    getCurrencyEmblem(currency) {
      if (currency === 'KRW') return "₩";
      else if (currency === 'USD') return "$";
    },
  },
}